<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form :form="form" layout="inline" :labelCol="{ style: { width: '70px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划名称" :help="null">
              <global-select
                v-decorator="['planName', { rules: [{ required: true }] }]"
                requestApi="/scp/scpMrpPlans/planNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2 }"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划版本" :help="null">
              <global-select
                v-decorator="['planVersion', { rules: [{ required: true }] }]"
                selectType="selectSearch"
                requestApi="/scp/scpMrpPlans/planVersionBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planName: form.getFieldsValue().planName }"
                searchParam="planVersion"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1500 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.PLAN_EXCEPTION_INFORMATION_LIST, // 表格方案配置唯一值
              }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a @click="goNextPage('供应/需求', record)">供应/需求</a>
                <a @click="goNextPage('物料', record)" class="ml10">物料</a>
                <a @click="goNextPage('例外', record)" class="ml10">例外</a>
                <a @click="goNextPage('计划选项', record)" class="ml10">计划选项</a>
                <a class="ml10" @click="$refs.dailyRecordModal.show(form.getFieldsValue(), true)">运行日志</a>
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
        <daily-record-modal ref="dailyRecordModal" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiScpMrpPlansPlanVersionList } from '@/api/scp/mrp-result-query/plan-exception-information'
import { generateLsTableResData } from '@/utils/util.js';
import DailyRecordModal from '@/components/DailyRecordModal/index'

export default {
  // eslint-disable-next-line
  name: 'Plan-exception-information', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {
    DailyRecordModal
  },
  data () {
    return {
       // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpMrpPlansPlanVersionList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      form: this.$form.createForm(this),
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [
        {
          title: '计划名称',
          dataIndex: 'planName',
          align: 'center',
          width: 140,
          stickyFixed: 'left'
        },
        {
          title: '计划版本',
          dataIndex: 'planVersion',
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'statusName',
          align: 'center'
        },
        {
          title: '数据收集起始时间',
          dataIndex: 'dataCollectStartDate',
          scopedSlots: { customRender: 'dataCollectStartDate' },
          width: 170,
          align: 'center',
          type: "text"
        },
        {
          title: '数据收集完成时间',
          dataIndex: 'dataCollectCompletionDate',
          scopedSlots: { customRender: 'dataCollectCompletionDate' },
          width: 170,
          align: 'center',
          type: "text"
        },
        {
          title: '计划运算起始时间',
          dataIndex: 'planStartDate',
          scopedSlots: { customRender: 'planStartDate' },
          width: 170,
          align: 'center',
          type: "text"
        },
        {
          title: '计划运算完成时间',
          dataIndex: 'planCompletionDate',
          scopedSlots: { customRender: 'planCompletionDate' },
          width: 170,
          align: 'center',
          type: "text"
        },
        {
          title: '计划类型',
          dataIndex: 'planTypeName',
          align: 'center'
        },
        {
          title: '说明',
          dataIndex: 'description',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          width: 290,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {},
  mounted () {},
  methods: {
    goNextPage (val, record) {
      const obj = JSON.parse(JSON.stringify(record))
      obj.organizationCode = this.organizationCodeOrigin
      if (val === "供应/需求") {
        this.$router.push({ name: "Supply-demand", query: { data: JSON.stringify(obj) } })
      }
      if (val === "物料") {
        this.$router.push({ name: "Query-materials", query: { data: JSON.stringify(obj) } })
      }
      if (val === "例外") {
        this.$router.push({ name: "Plan-exception-query", query: { data: JSON.stringify(obj) } })
      }
      if (val === "计划选项") {
        const obj2 = JSON.parse(JSON.stringify(record))
        obj2.planVersion = ""
        this.$router.push({ name: "mrp-plan-name-detail", query: { status: "look", row: JSON.stringify(obj2) } })
      }
    },
    // 表单搜索
    onSearch () {
      if (!this.form.getFieldsValue().planName) {
        this.$message.warning('计划名称不能为空')
        return;
      }
      if (!this.form.getFieldsValue().planVersion) {
        this.$message.warning('计划版本不能为空')
        return;
      }
      this.$refs.dataTable.searchParams = this.form.getFieldsValue();
      this.$refs.dataTable.getData();
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.form.resetFields()
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less">
</style>
